import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';

type DeleteTriggerArgs = {
  triggerUid: string;
};

const deleteTrigger = async ({ triggerUid }: DeleteTriggerArgs) => {
  const response = await API.delete(`/api/internal/triggers/${triggerUid}`);

  return response.data;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<unknown, BaseErrorResponse, DeleteTriggerArgs>,
  'mutationFn'
>;

const useDeleteTriggerMutation = (options?: ReactQueryMutationOptions) => {
  return useAppMutation({
    mutationFn: deleteTrigger,
    ...options,
  });
};

export default useDeleteTriggerMutation;
